import React from "react";

function LinkIcon() {
  return (
    <span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9996 2.3999C9.3488 2.3999 7.1996 4.5491 7.1996 7.1999V8.3999H5.9996C5.3876 8.3999 4.87401 8.85952 4.80681 9.46792L3.60681 20.2679C3.56961 20.6063 3.6776 20.9459 3.9056 21.2003C4.1336 21.4547 4.4588 21.5999 4.7996 21.5999H19.1996C19.5404 21.5999 19.8656 21.4547 20.0936 21.2003C20.3216 20.9459 20.4296 20.6063 20.3924 20.2679L19.1924 9.46792C19.1252 8.85952 18.6116 8.3999 17.9996 8.3999H16.7996V7.1999C16.7996 4.5491 14.6504 2.3999 11.9996 2.3999ZM14.3996 8.3999V7.1999C14.3996 5.8739 13.3256 4.7999 11.9996 4.7999C10.6736 4.7999 9.5996 5.8739 9.5996 7.1999V8.3999H14.3996ZM7.1996 11.9999C7.1996 11.3375 7.7372 10.7999 8.3996 10.7999C9.062 10.7999 9.5996 11.3375 9.5996 11.9999C9.5996 12.6623 9.062 13.1999 8.3996 13.1999C7.7372 13.1999 7.1996 12.6623 7.1996 11.9999ZM15.5996 10.7999C14.9372 10.7999 14.3996 11.3375 14.3996 11.9999C14.3996 12.6623 14.9372 13.1999 15.5996 13.1999C16.262 13.1999 16.7996 12.6623 16.7996 11.9999C16.7996 11.3375 16.262 10.7999 15.5996 10.7999Z"
          fill="#111827"
        />
      </svg>
    </span>
  );
}

export default LinkIcon;
